import { render } from "./InstructorOverview.vue?vue&type=template&id=42cb0b39"
import script from "./InstructorOverview.vue?vue&type=script&lang=js"
export * from "./InstructorOverview.vue?vue&type=script&lang=js"

import "./InstructorOverview.vue?vue&type=style&index=0&id=42cb0b39&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__